<form class="popupForm" style="min-height: 300px;" [formGroup]="componentForm">
  <div class="common" mat-dialog fxLayout="column" fxLayoutAlign="space-between" style="min-height: inherit;">
    <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between end">
      <span *ngIf="!this.listItem">{{'new_group_creation' | GetLabelPipe}}</span>
      <span *ngIf="this.listItem">{{'edit_group_settings' | GetLabelPipe}}</span>
      <button mat-icon-button mat-dialog-close id="close-upload" alt="close" title="close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-dialog-content class="when-fx-layout-broke" style="display: flex !important; min-height: 300px;">
      <div class="internal-spinner" *ngIf="state === 'loading'">
        <svg class="spinner" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
        </svg>
      </div>
      <div *ngIf="state === 'error'">
        >.< error. <br>{{errMsg}}
      </div>
      <div *ngIf="state==='edit'">
        <div fxLayout="row" fxLayoutAlign="start center" class="field-error-message"
             *ngIf="validationResult && !validationResult.isValid && validationResult.message">
          <mat-icon color="warn">error</mat-icon><span>{{ validationResult.message }}</span>
          <br>
        </div>
        <div>
          &nbsp;
        </div>
        <mat-form-field appearance="outline" color="accent" style="width: 100%">
          <mat-label>{{'group_name' | GetLabelPipe}}</mat-label>
          <input matInput id="mkdir-name-input" type="text"
                 (keydown)="$event.stopPropagation()" (keyup)="$event.stopPropagation()" (keydown.enter)="handleSubmit($event)"
                 formControlName="textInput">
        </mat-form-field>

<!--        <div class="flex-row-start">-->
<!--          <mat-form-field appearance="outline" color="accent" style="width: 40%">-->
<!--            <select matNativeControl formControlName="privacyInput">-->
<!--              <option value="confirmation">Confirmation</option>-->
<!--              <option value="public">Public</option>-->
<!--            </select>-->
<!--            <mat-label>Moderation</mat-label>-->
<!--          </mat-form-field>-->
<!--          <div class="form-right-explainer-label">⚠️Moderation label</div>-->
<!--        </div>-->

        <br><br>
        <mat-form-field appearance="outline" color="accent">
          <mat-label>groupType groupType</mat-label>
          <select matNativeControl formControlName="groupType">
            <option value="smart_class">Smart class</option>
            <option value="user_class">User class</option>
            <option value="cup">Cup</option>
          </select>
        </mat-form-field>

        <ng-container *ngIf="groupType.value != 'smart_class'">
        <br><br>
        <div class="flex-row-start">
          <div class="form-checkbox">
            <mat-checkbox formControlName="privacyCheck"></mat-checkbox>
          </div>
          <div class="form-checkbox-label">{{'enable_moderation' | GetLabelPipe}}</div>
        </div>
        </ng-container>

        <div>
          <app-quick-uploader [picture_src]="picture_src_preview" [aspect_ratio]="0.67"
                              (new_picture_src_ava)="picture_src_ava = $event"
                              (new_picture_src_icon)="picture_src_icon = $event"
                              (new_picture_src_preview)="picture_src_preview = $event"
                              (new_aspect_ratio)="aspect_ratio = $event"
          >
          </app-quick-uploader>
        </div>
      </div>
    </mat-dialog-content>
    <div *ngIf="this.state !== 'loading'" fxLayout="row" fxLayoutAlign="{{this.listItem ? 'space-between end' : 'end end'}}" fxLayoutGap="10px">
      <div *ngIf="this.listItem">
        <button type="submit" class="widerButton font16" mat-raised-button color="warn" (click)="deleteClass()">
          {{'delete' | GetLabelPipe}}
        </button>
      </div>
      <div fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="10px">
        <button mat-button class="cancel widerButton font16" (click)="onNoClick()">
          {{'cancel' | GetLabelPipe}}
        </button>
        <button type="submit" class="widerButton font16" mat-raised-button color="accent" (click)="handleSubmit()">
          {{'save' | GetLabelPipe}}
        </button>
      </div>
    </div>
  </div>
</form>
